// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1VDep","choiceBoxes":"toolbarselects_choiceBoxes__258rS","simpleField":"toolbarselects_simpleField__yR-fy"};